import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';

class FacilityOrderNewFlowRoundingItemsModalStore extends BaseViewStore {
    @observable accessor isLoading = false;
    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.modalParams.data.id;
        this.modalParams = componentsProps.modalParams;
        this.roundFacilityOrderTemplateItems = componentsProps.modalParams.data.roundItems;
        this.items = componentsProps.modalParams.data.items;
    }

    @action.bound
    async roundItems() {
        this.isLoading = true;
        if (this.roundFacilityOrderTemplateItems) {
            await this.roundFacilityOrderTemplateItems(this.items);
        }
        this.modalParams.close();
        this.isLoading = false;
    }
    @action.bound
    async setIncludeItem(item) {
        item.includeItem = !item.includeItem;
    }
}

export default FacilityOrderNewFlowRoundingItemsModalStore;